module.exports = __webpack_public_path__ + "img/balance_sheet_manual_2.276a4dff.png";